import React from 'react';
import { useSelector } from 'react-redux';
import { Typology } from 'types';
import { OtherSelectionSelectors } from '../../../common/config/store';
import StyledTable from '../../organisms/styled-table';
import ListModifier from '../../organisms/list-modifier';
import { useIntl } from '../../../common/config/i18n';
import { Empty } from 'antd';

type Props = {
  onClickEdit?: (typology: Typology) => void;
  onClickDelete?: (typology: Typology) => void;
  canWrite?: boolean;
};

const TypologyTable: React.FC<Props> = ({ onClickEdit, onClickDelete, canWrite }: Props) => {
  const { t } = useIntl();
  const data = useSelector(OtherSelectionSelectors.typologiesSelector);

  const columns = [
    {
      title: t('table', 'CHART_TYPOLOGY'),
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: t('table', 'CHART_LINKED_PRODUCT_CODE'),
      key: 'productCodes',
      render: (record: Typology) => {
        const codes = record?.productCodes
          ?.map((code, i) => {
            let str = code.name;
            if (i > 0) str = `, ${code.name}`;
            return str;
          })
          .join('');
        return <div>{codes}</div>;
      },
    },
    {
      title: t('table', 'COLUMN_EDIT_DELETE'),
      key: 'modifier',
      shouldBeAdmin: true,
      render: (record: Typology) => (
        <ListModifier
          hideEditButton={!canWrite}
          hideDeleteButton={!canWrite}
          onDelete={() => onClickDelete?.(record)}
          onEdit={() => onClickEdit?.(record)}
        />
      ),
    },
  ];

  const calculatedColumns = canWrite ? columns : columns.filter((column) => !column.shouldBeAdmin);

  return (
    <StyledTable
      rowKey="id"
      pagination={false}
      dataSource={data}
      columns={calculatedColumns}
      locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
    />
  );
};

export default TypologyTable;
